// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f528b7e4/" + chunkId + "." + __webpack_require__.h() + ".vf528b7e4.js";
};